import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import Title from 'components/Title';

import styles from './styles.module.scss';

const EmptyMessage = ({ text }) => (
	<Container innerClassName={styles.inner}>
		<Title text={text} />
	</Container>
);

EmptyMessage.propTypes = {
	text: PropTypes.string.isRequired
};

export default EmptyMessage;
